import { createAction } from "@ngrx/store";

export const setUnreadNotification = createAction(
  '[UnreadNotification] Set UnreadNotification',
  (unreadNotification: number) => ({unreadNotification})
);
